import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ShieldCheck } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";
import { PermissionsModal } from "./PermissionsModal";

// زر يفتح Modal الصلاحيات لموظف معيّن — يُستخدم من الفرع/القسم/التعديل.
export const PermsButton = ({ userId, userName, onSaved, className = "", label, small = false }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <>
      <NeuButton
        type="button"
        className={`flex items-center gap-2 ${small ? "!py-1 !px-3 text-xs" : ""} ${className}`}
        data-testid={`perms-open-${userId}`}
        onClick={() => setOpen(true)}
      >
        <ShieldCheck className={small ? "h-3.5 w-3.5" : "h-4 w-4"} />
        {label || t("perms.button")}
      </NeuButton>
      {open ? (
        <PermissionsModal
          userId={userId}
          userName={userName}
          onClose={() => setOpen(false)}
          onSaved={onSaved}
        />
      ) : null}
    </>
  );
};
